// Pagination.js — Controle de paginação reutilizável (Livros e Autores).
// Mostra ‹ anterior, números (com reticências quando há muitas páginas) e › próximo.
import React from "react";

// Gera a lista de páginas a exibir, com reticências (…) para faixas grandes.
const buildPages = (current, total) => {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const pages = [1];
  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);
  if (start > 2) pages.push("…");
  for (let i = start; i <= end; i++) pages.push(i);
  if (end < total - 1) pages.push("…");
  pages.push(total);
  return pages;
};

// `rolarAte` (opcional): id do elemento que deve voltar à vista a cada troca,
// no lugar do topo da página. É para grades que moram no MEIO de uma página
// longa — o acervo do Clube —, onde voltar ao topo largaria a pessoa várias
// telas acima dos livros que ela estava folheando.
const Pagination = ({ pagina, totalPaginas, onChange, rolarAte }) => {
  if (totalPaginas <= 1) return null;

  const go = (n) => {
    const alvo = Math.min(Math.max(1, n), totalPaginas);
    onChange(alvo);
    const elemento = rolarAte && document.getElementById(rolarAte);
    if (elemento) elemento.scrollIntoView({ behavior: "smooth", block: "start" });
    else window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const base = "min-w-9 h-9 px-3 rounded-lg text-sm font-medium flex items-center justify-center transition-colors";

  return (
    <nav className="flex items-center justify-center gap-2 mt-10" aria-label="Paginação">
      <button
        onClick={() => go(pagina - 1)}
        disabled={pagina <= 1}
        className={base + " border border-line text-white/80 hover:bg-white/10 disabled:opacity-40 disabled:cursor-not-allowed"}
        aria-label="Página anterior"
      >
        <i className="bi bi-chevron-left text-xs" />
      </button>

      {buildPages(pagina, totalPaginas).map((p, i) =>
        p === "…" ? (
          <span key={`e${i}`} className="px-1 text-white/40 select-none">…</span>
        ) : (
          <button
            key={p}
            onClick={() => go(p)}
            aria-current={p === pagina ? "page" : undefined}
            className={base + (p === pagina
              ? " bg-insigne-orange text-paper"
              : " border border-line text-white/80 hover:bg-white/10")}
          >
            {p}
          </button>
        )
      )}

      <button
        onClick={() => go(pagina + 1)}
        disabled={pagina >= totalPaginas}
        className={base + " border border-line text-white/80 hover:bg-white/10 disabled:opacity-40 disabled:cursor-not-allowed"}
        aria-label="Próxima página"
      >
        <i className="bi bi-chevron-right text-xs" />
      </button>
    </nav>
  );
};

export default Pagination;
